// extracted by mini-css-extract-plugin
module.exports =  {"section":"_33974c2b58--section--HEw1f","header":"_33974c2b58--header--Ups7q","recommendations":"_33974c2b58--recommendations--_7eAd","action":"_33974c2b58--action--ejJCL"};